import BaseNotification from '../BaseNotification'

export default class BookingExpiresTomorrow extends BaseNotification {
  get processedMessage(): string {
    return super.processedMessage.replace(
      '{paymentModalLink}',
      this.paymentModalLink,
    )
  }

  get paymentModalLink(): string {
    return this.notification.paymentAllowed
      ? `
          <router-link
            :to="{
              name: 'makePayment',
              query: { bookingId: '${this.notification.enquiryId}' },
            }"
          >
            Pay now
          </router-link>.
        `
      : ''
  }

  get iconClass(): string {
    return 'sc-icon-calendar-expire'
  }
}
